import { signal } from '@preact/signals-react';

export interface ParquetResultKeyFields {
  urlForGetRequest?: string;
  urlForHeadRequest?: string;
  columnsGroupForHeatmap?: string[];
  columnsForQuery?: string[];
  optionalColumnsForQuery?: string[];
  outputFormat?: 'rows' | 'columnar';
}

export const getParquetResultKey = ({
  urlForGetRequest,
  urlForHeadRequest,
  columnsForQuery,
  columnsGroupForHeatmap,
  outputFormat,
  optionalColumnsForQuery,
}: ParquetResultKeyFields): string =>
  JSON.stringify([
    'parquet',
    urlForGetRequest,
    urlForHeadRequest,
    columnsForQuery || columnsGroupForHeatmap,
    outputFormat,
    optionalColumnsForQuery,
  ]);

// Fraction of rows decoded per parquet query, keyed by `getParquetResultKey` so every consumer sees the same value.
export const parquetLoadProgress = signal<Record<string, number>>({});

export const setParquetLoadProgress = (resultKey: string, loadedFraction?: number) => {
  const nextProgress = { ...parquetLoadProgress.peek() };
  if (loadedFraction === undefined) delete nextProgress[resultKey];
  else nextProgress[resultKey] = loadedFraction;
  parquetLoadProgress.value = nextProgress;
};

/** Reading this inside a `useSignals` component re-renders it as progress changes. */
export const getParquetFileLoadProgress = (parquetFile?: ParquetResultKeyFields): number | undefined =>
  parquetFile?.urlForGetRequest ? parquetLoadProgress.value[getParquetResultKey(parquetFile)] : undefined;
